module.exports = __webpack_public_path__ + "img/icon3.331ba13f.331ba13f.svg";